// extracted by mini-css-extract-plugin
export var headerContainer = "header-module--header-container--2i-sL";
export var header = "header-module--header--26VYx";
export var scrolled = "header-module--scrolled--2Uy76";
export var disabled = "header-module--disabled--1_fAx";
export var logoContainer = "header-module--logo-container--3-FeZ";
export var navContainer = "header-module--nav-container--2CfxS";
export var navbar = "header-module--navbar--U6DoO";
export var searching = "header-module--searching--2mGkt";